// Per-checkout dev "slot" identity (see scripts/setup-slot.sh). Each local
// checkout runs in a numbered slot with an assigned hue so concurrent
// checkouts are visually distinguishable — Hubble prefixes its document title
// with the slot number and tints its nav bar with the slot color. These env
// vars are written into `.mise.local.toml` by setup-slot.sh and are absent in
// deployed builds, so both helpers return undefined outside local dev.

import chroma from "chroma-js";

export function devSlotNumber(): string | undefined {
  const slot = import.meta.env["VITE_FS_SLOT"];
  return slot ? String(slot) : undefined;
}

export function devSlotColor(): string | undefined {
  return import.meta.env["VITE_FS_SLOT_COLOR"] || undefined;
}

// Readable text color for the slot-tinted nav bar — dark text on light slot
// colors (yellow, lime), white otherwise. Returns undefined outside local dev
// so callers fall back to their default (white). #1a1a2e matches --color-foreground.
export function devSlotForeground(): string | undefined {
  const color = devSlotColor();
  if (!color) return undefined;
  try {
    return chroma(color).luminance() > 0.55 ? "#1a1a2e" : "#ffffff";
  } catch {
    return "#ffffff";
  }
}
